
import {Vue} from "vue-class-component";

export default class LoginForm extends Vue {
}
